import classes from './Navbar.module.scss';
import { FC, useEffect, useRef, useState } from 'react';
import { Close } from 'components/icons';
import { Menu } from '@mui/icons-material';

type NavbarProps = FC<{}>;

const Navbar: NavbarProps = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);
    const ref = useRef<any>();

    useEffect(() => {
        const handleOutsideClick = (event: any) => {
            const excludedDiv = document.getElementById('mobile-container');
            if (ref.current && !ref.current.contains(event.target) && (!excludedDiv || !excludedDiv.contains(event.target))) {
                setIsSidebarOpen(false);
            }
        };
        document.addEventListener('mousedown', handleOutsideClick);
        document.addEventListener('touchstart', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
            document.removeEventListener('touchstart', handleOutsideClick);
        };
    }, []);

    return (
        <>
            <div className={classes.sections}>
                <div className={classes.link}>
                    <a href="https://sis.city">
                        <p>/ sis</p>
                    </a>
                    <a href="https://sis.city/chi-siamo/">
                        <p>/ chi siamo</p>
                    </a>
                    <a href="https://sis.city/servizi/">
                        <p>/ servizi</p>
                    </a>
                    <a href="https://sis.city/certificazioni/">
                        <p>/ certificazioni</p>
                    </a>
                    <a href="https://sis.city/contatti/">
                        <p>/ contatti</p>
                    </a>
                </div>
                <div onClick={() => setIsSidebarOpen(prev => !prev)} className={classes.hamburger} ref={ref}>
                    <Menu />
                </div>
            </div>
            <div
                id="mobile-container"
                className={` ${classes.sidebar} ${!isSidebarOpen ? classes.closedSidebar : classes.openSidebar} `}
            >
                <div onClick={() => setIsSidebarOpen(prev => !prev)} ref={ref} className={classes.close}>
                    <Close fill={'#0557ba'} />
                </div>
                <a href="https://sis.city">
                    <p>/ sis</p>
                </a>
                <a href="https://sis.city/chi-siamo/">
                    <p>/ chi siamo</p>
                </a>
                <a href="https://sis.city/servizi/">
                    <p>/ servizi</p>
                </a>
                <a href="https://sis.city/certificazioni/">
                    <p>/ certificazioni</p>
                </a>
                <a href="https://sis.city/contatti/">
                    <p>/ contatti</p>
                </a>
            </div>
        </>
    );
};

export default Navbar;

